import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface GobWeightsService {
  addWeightComment: (comment: apsCommands.AddGobWeightComment) => angular.IPromise<any>;
  getGobWeightHistoryReport(shopId: string,
                            startDate: Date,
                            endDate: Date): angular.IPromise<apsViewModels.GobWeightsReport>;
  deleteGobWeight: (weight: apsCommands.DeleteGobWeight) => angular.IPromise<any>;
}

class GobWeightsServiceImpl implements GobWeightsService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  addWeightComment(comment: apsCommands.AddGobWeightComment): angular.IPromise<any> {
    return this.httpService.post(Endpoints.GOB_WEIGHT_COMMENT, comment);
  }

  getGobWeightHistoryReport(shopId: string,
                            startDate: Date,
                            endDate: Date): angular.IPromise<apsViewModels.GobWeightsReport> {
    return this.httpService.get<apsViewModels.GobWeightsReport>(Endpoints.GOB_WEIGHT_HISTORY_REPORT, {
      shopId: shopId,
      startDate: startDate,
      endDate: endDate
    });
  }

  deleteGobWeight(deleteWeight: apsCommands.DeleteGobWeight)
  {
    return this.httpService.post(Endpoints.GOB_WEIGHT_DELETE, deleteWeight);    
  }
}

export default angular.module('aps.services.gobWeights', [HttpServiceName])
  .service('gobWeightsService', GobWeightsServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/measures/gobWeights.service.ts